/**
 * TerminalToolbar — the terminal widget's floating-toolbar slot: the "Agent control"
 * toggle next to the theme picker.
 */
import { TerminalAgentControlToggle } from "./TerminalAgentControlToggle";
import { TerminalThemeMenu } from "./TerminalThemeMenu";

interface Props {
  id: string;
  data: Record<string, unknown>;
}

export function TerminalToolbar(props: Props) {
  return (
    <div className="flex items-center gap-1">
      <TerminalAgentControlToggle {...props} />
      <TerminalThemeMenu {...props} />
    </div>
  );
}
